/*eslint-disable */
/**
 * @copyright    Copyright © 2019-2025 MiniVentureLab
 * @author       Shubham Shukla  <shukla@gide.ai>
 * @package      Gide
 * @license      Proprietary
 * @description  AES encrypt and dcrypt functionality
 * 
 * 
 */

var aes256 = require('aes256')

let encryptAndDecrypt = {
  /**
   * aes_encrypt
   */
  aes_encrypt(key, data) {
    key = key+process.env.VUE_APP_AES_SALT;
    let cipher = aes256.createCipher(key);
    return cipher.encrypt(JSON.stringify(data));
  },

  /*
   * aes_decrypt
   */
  aes_decrypt(key, data) {
    key = key+process.env.VUE_APP_AES_SALT;
    let cipher = aes256.createCipher(key);
    return cipher.decrypt(data);
  },

  /*
  * decrypt PII Data
  */
  async decryptPIIData(user_id, userRespObj) {
    if (userRespObj.user_mobile) {
      userRespObj.user_mobile = await await JSON.parse(encryptAndDecrypt.aes_decrypt(user_id, userRespObj.user_mobile))
    }  

    if (userRespObj.user_email) {
      userRespObj.user_email = await await JSON.parse(encryptAndDecrypt.aes_decrypt(user_id, userRespObj.user_email))
    }  

    if (userRespObj.parent_email) {
      userRespObj.parent_email = await await JSON.parse(encryptAndDecrypt.aes_decrypt(user_id, userRespObj.parent_email))
    }

    if (userRespObj.parent_mobile) {
      userRespObj.parent_mobile = await await JSON.parse(encryptAndDecrypt.aes_decrypt(user_id, userRespObj.parent_mobile))
    }  

    if (userRespObj.parent_email_list) {
      userRespObj.parent_email_list = await JSON.parse(encryptAndDecrypt.aes_decrypt(user_id, userRespObj.parent_email_list))
    }

    return userRespObj
  }  
}

export default encryptAndDecrypt;